import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M56.13 12.47C50.72 5.70997 38.51 1.70996 31.41 1.70996C24.31 1.70996 11.99 5.70997 6.58005 12.47C-3.10995 24.58 3.50003 51.22 3.50003 51.22C3.50003 51.22 4.16002 29.64 11.43 23.26C17.62 17.82 23.3 19.91 31.36 19.91C39.42 19.91 45.1 17.83 51.29 23.26C58.56 29.65 59.22 51.22 59.22 51.22C59.22 51.22 65.82 24.58 56.13 12.47Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.7901 2.29004C24.7901 2.29004 22.3102 7.89996 25.7802 19.96"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M17.2 4.76001C17.2 4.76001 13.24 11.04 16.21 20.45" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M13.7301 6.57996C13.7301 6.57996 8.45011 12.03 10.5901 23.59"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M6.24014 12.47C6.24014 12.47 0.680157 23.75 5.63016 35.48"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M37.9302 2.29004C37.9302 2.29004 40.4102 7.89996 36.9402 19.96"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M45.5303 4.76001C45.5303 4.76001 49.4903 11.04 46.5203 20.45" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M48.9902 6.57996C48.9902 6.57996 54.2702 12.03 52.1302 23.59"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.4802 12.47C56.4802 12.47 62.0403 23.75 57.0903 35.48"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
